export const TICKET_LATLNG = 'TICKET_LATLNG'